import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Calendar, CalendarOptions, DatesSetArg, EventInput } from '@fullcalendar/core';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular/full-calendar.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CreateEventoComponent } from './create-evento/create-evento.component';
import { AgendaDto, ConsultaDto, ConsultaServiceProxy, CreateConsultaDto, CreateEventoDto, EssentialProfisisonalSaudeDto, EventoDto, EventoServiceProxy, PacienteGroupDto, PacienteServiceProxy, ProfissionalSaudeServiceProxy, StatusConsultaEnum, TipoEvento, UpdateConsultaDto } from '@shared/service-proxies/service-proxies';
import { CreateHorarioDisponivelComponent } from './create-horario-disponivel/create-horario-disponivel.component';
import { Observable, Subscription } from 'rxjs';
import { AppComponentBase } from '@shared/app-component-base';
import { EditEventoComponent } from './edit-evento/edit-evento.component';
import * as moment from 'moment-timezone';
import { HttpClient } from '@angular/common/http';
import { finalize, map } from 'rxjs/operators';
import { EditConsultaComponent } from '../default-consultas/edit-consulta/edit-consulta.component';
import { StringUtils } from '@shared/helpers/StringUtils';
import { CreateConsultaComponent } from '../default-consultas/create-consulta/create-consulta.component';
import { GerenciarDisponibilidadeDiaComponent } from './gerenciar-disponibilidade-dia/gerenciar-disponibilidade-dia.component';
let currentViewOption: 'mes' | 'semana' | 'dia' = 'semana';
@Component({
  selector: 'custom-calendar',
  templateUrl: './custom-calendar.component.html',
  styleUrls: ['./custom-calendar.component.scss']
})
export class CustomCalendarComponent extends AppComponentBase implements OnInit, OnDestroy, OnChanges {
  @Input() agenda: AgendaDto;
  @Input() gerenciarHorarios: boolean = false;
  public title: string = "";
  public currentCalendarView = "view-semana"
  public viewOption: 'mes' | 'dia' | 'semana' = "semana";
  private eventos: any[] = [];
  private feriados: EventInput[] = [];
  private anoAtual: number = 0;
  private _subscriptions: Subscription[] = [];
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    viewDidMount: this.updateTitle.bind(this),
    dayHeaderContent: this.customDayHeader.bind(this),
    initialView: 'timeGridWeek',
    allDaySlot: false,
    firstDay: 0,
    locale: ptBrLocale,
    timeZone: 'local',
    headerToolbar: {
      left: 'title,customPrevButton,customNextButton,today',
      center: 'timeGridDay,timeGridWeek,dayGridMonth',
      right: '',
    },
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    },
    titleFormat: { month: 'short', day: 'numeric' },
    datesSet: this.onDatesSet.bind(this),
    eventClick: this.eventoClick.bind(this),
    eventContent: this.eventContent.bind(this),
    dayCellDidMount: this.customDayCellDidMount.bind(this),
    dateClick: this.onDateClick.bind(this)
  };

  constructor(
    public injector: Injector,
    private readonly _consultaService: ConsultaServiceProxy,
    private readonly _pacienteService: PacienteServiceProxy,
    private readonly _profissionalService: ProfissionalSaudeServiceProxy,
    private _eventoService: EventoServiceProxy,
    private _modalService: BsModalService,
    private readonly http: HttpClient,
  ) {
    super(injector);
  }

  ngOnInit() {
    const hoje = new Date();
    this.anoAtual = hoje.getFullYear();
    this.gerenciarHorarios = this.gerenciarHorarios && this.appSession.clinicaId && !this.appSession.profissionalId;
    if (!this.appSession.clinicaId && this.appSession.profissionalId) this.gerenciarHorarios = true;

    this._subscriptions.push(this.getEventos());
    this.getFeriados(new Date().getFullYear()).subscribe(feriados => {
      this.feriados = feriados;
    });

    const handler = (event: MouseEvent) => {
      const el = (event.target as HTMLElement).closest('[data-action="gerenciar-dia"]');
      if (!el) return;
      const dateStr = (el as HTMLElement).dataset.date;
      if (dateStr) this.abrirGerenciarDia(new Date(dateStr));
    };
    document.addEventListener('click', handler);
    this._subscriptions.push({ unsubscribe: () => document.removeEventListener('click', handler) } as any);

    if (this.gerenciarHorarios) {
      setTimeout(() => this.atualizarVisibilidadeIcones(), 300);
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.agenda) {
      this.calendarOptions = {
        ...this.calendarOptions,
        slotMinTime: this.agenda?.horarioInicio,
        slotMaxTime: this.agenda?.horarioFim,
        slotDuration: `00:${this.agenda.duracaoConsulta}:00`
      };
    }
  }

  eventContent(arg) {
    const { vazio, status, nome, horario, tipo, nomePaciente, urlFoto, tipoConsulta } = arg.event.extendedProps;

    if (tipo == 'horario-livre') {
      return {
        html: `<div class="slot-disponivel"><i class="far fa-thumbs-up"></i></div>`
      };
    }

    if (tipo == "feriado") {
      return {
        html: `<div class="slot-feriado"><i class="far fa-flag"></i></div>`
      };
    }

    if (vazio) {
      if (tipo == 'botao-novo-evento') {
        if (this.gerenciarHorarios) {
          return {
            html: `<div class="slot-disponivel-botao"><i class="hgi hgi-stroke hgi-plus-sign"></i></div>`
          }
        } else {
          return {
            html: `<div class="slot-em-branco"></div>`
          }
        }
      }
    }

    let eventClass = '';
    let iconEvent = '';
    let icon = 'hgi hgi-stroke hgi-clock-01'
    switch (status) {
      case StatusConsultaEnum._0:
        eventClass = 'evento-confirmado';
        iconEvent = "icone-confirmado";
        icon = 'hgi hgi-stroke hgi-clock-01';
        break;
      case StatusConsultaEnum._2:
        eventClass = 'evento-pendente';
        iconEvent = "icone-pendente";
        icon = 'hgi hgi-stroke hgi-clock-05';
        break;
      case StatusConsultaEnum._1:
        eventClass = 'evento-cancelado';
        iconEvent = "icone-cancelado";
        icon = 'hgi hgi-stroke hgi-cancel-circle';
        break;
      case StatusConsultaEnum._3:
        eventClass = 'evento-realizado';
        iconEvent = "icone-realizado";
        icon = 'hgi hgi-stroke hgi-checkmark-circle-02';
        break;
    }

    const start = new Date(arg.event.start);
    const end = new Date(arg.event.end);
    const durationInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
    const eventoCurto = currentViewOption && currentViewOption != "mes" && durationInMinutes < this.agenda.duracaoConsulta;

    if (eventoCurto) {
      return {
        html: `
        <div class="evento-personalizado-curto d-flex flex-column h-100 justify-content-between ${eventClass}">
          <div class="row d-flex align-items-center px-2">
            <div class="col-lg-8 col-12 title-container">
              <span class="font-primary-gray-500 horario">${horario}</span>
            </div>
            <div class="icon-container col-4 d-flex justify-content-end">
              <i class="${icon} ${iconEvent} icone-evento"></i>
            </div>
          </div>
        </div>
        `
      };
    } else {
      return {
        html: `
        <div class="evento-personalizado d-flex flex-column h-100 justify-content-between ${eventClass}">
          <div>
            <div class="row d-flex align-items-center user-icon-container p-2">
              ${!urlFoto
            ? `<div class="user-icon col-auto p-0"><i class="hgi hgi-stroke hgi-user-circle-02"></i></div>`
            : `<div class="user-icon col-auto p-0"><img src="${urlFoto}" class="foto-perfil" alt="Foto de perfil"></div>`
          }
              <div class="col text-truncate-container">
                <span class="text-truncate d-block font-primary-gray-700" title="${nomePaciente || nome}">${(nomePaciente || nome) || 'Sem nome'}</span>
              </div>
            </div>
            <div class="row d-flex align-items-center p-2 container-title">
              <div class="text-truncate-container mt-1 col-12">
                <span class="text-truncate d-block font-primary-gray-500 title" title="${arg.event.title}">${arg.event.title}</span>
                 ${StringUtils.isNullOrEmpty(tipoConsulta)
            ? `<div></div>`
            : ` <span class="text-truncate d-block font-primary-gray-500 title" title="${tipoConsulta}">${tipoConsulta}</span>`
          }
              </div>
            </div>
          </div>

          <div class="row d-flex align-items-center mt-auto p-2 pt-1 horario-container">
            <div class="col-lg-8 col-12 title-container" title="${arg.event.title}">
              <span class="font-primary-gray-500 horario">${horario}</span>
            </div>
            <div class="icon-container col-4 d-flex justify-content-end">
              <i class="${icon} ${iconEvent} icone-evento"></i>
            </div>
          </div>
        </div>
        `
      };
    }
  }

  onDatesSet(info: DatesSetArg) {
    const start = new Date(info.start);
    const end = new Date(info.end);

    const stepMinutes = this.agenda?.duracaoConsulta ?? 30;
    const allSlots = this.generateSlots(start, end, stepMinutes);

    // Separa os eventos reais e os disponíveis
    const eventosDisponiveisOriginais = this.eventos.filter(e => e.extendedProps?.tipo === TipoEvento._0);
    const eventosReais = this.eventos.filter(e => e.extendedProps?.tipo !== TipoEvento._0);
    const eventosReaisInicios = new Set(eventosReais.map(e => new Date(e.start).toISOString()));

    const eventosDisponiveis: EventInput[] = [];
    const eventosFeriado: EventInput[] = [];

    for (const ev of eventosDisponiveisOriginais) {
      const evStart = new Date(ev.start);
      const evEnd = new Date(ev.end);

      let current = new Date(evStart);
      while (current < evEnd) {
        const slotStart = new Date(current);
        const slotEnd = new Date(current);
        slotEnd.setMinutes(slotEnd.getMinutes() + stepMinutes);

        // Só adiciona se estiver dentro do intervalo original
        if (slotEnd <= evEnd && !this.colideComEventoReal(slotStart, slotEnd, eventosReais)) {
          eventosDisponiveis.push(this.buildEventoDisponivel(slotStart, slotEnd));
        }

        current.setMinutes(current.getMinutes() + stepMinutes);
      }
    }

    // 3. Gera "botão novo evento" para dias 100% vazios
    const minTime: string = this.calendarOptions.slotMinTime.toString();  // Exemplo: 08:00
    const maxTime: string = this.calendarOptions.slotMaxTime.toString();

    const getTimeHHMM = (date: Date): string => {
      return date.toTimeString().split(':').slice(0, 2).join(':'); // '14:00'
    };

    const isTimeInRange = (time: string, minTime: string, maxTime: string): boolean => {
      return time >= minTime && time < maxTime;
    };

    const eventosOcupados = [...eventosReais, ...eventosDisponiveis];
    const eventosOcupadosIntervalos = eventosOcupados.map(e => ({
      start: new Date(e.start),
      end: new Date(e.end)
    }));

    const slotLivre = (slotStart: Date, slotEnd: Date): boolean => {
      return !eventosOcupadosIntervalos.some(ev =>
        (slotStart < ev.end && slotEnd > ev.start)
      );
    };

    const slotsBotaoNovo = allSlots
      .map(slotStr => {
        const slotStart = new Date(slotStr);
        const slotEnd = new Date(slotStart);
        slotEnd.setMinutes(slotEnd.getMinutes() + stepMinutes);
        return { slotStart, slotEnd };
      })
      .filter(({ slotStart, slotEnd }) => {
        const time = getTimeHHMM(slotStart);
        return isTimeInRange(time, minTime, maxTime) && slotLivre(slotStart, slotEnd);
      });

    const eventosBotaoNovo = slotsBotaoNovo.map(({ slotStart, slotEnd }) =>
      this.buildEventoBotao(slotStart, slotEnd)
    );

    for (const feriado of this.feriados) {
      let data: Date;
      if (typeof feriado.start === 'string') {
        const [year, month, day] = feriado.start.split('-').map(Number);
        data = new Date(year, month - 1, day);
      }

      if (isNaN(data.getTime())) {
        console.warn('Data inválida:', feriado.start);
        continue;
      }

      data.setHours(Number(minTime.split(':')[0]), Number(minTime.split(':')[1]));

      const endHour = Number(maxTime.split(':')[0]);
      const endMinute = Number(maxTime.split(':')[1]);

      const diaFeriadoSlots: { slotStart: Date; slotEnd: Date }[] = [];

      let current = new Date(data);
      while (current.getHours() < endHour || (current.getHours() === endHour && current.getMinutes() < endMinute)) {
        const slotStart = new Date(current);
        const slotEnd = new Date(current);
        slotEnd.setMinutes(slotEnd.getMinutes() + stepMinutes);

        const time = getTimeHHMM(slotStart);
        if (isTimeInRange(time, minTime, maxTime) && slotLivre(slotStart, slotEnd)) {
          diaFeriadoSlots.push({ slotStart, slotEnd });
        }

        current.setMinutes(current.getMinutes() + stepMinutes);
      }

      const eventosDoDia = diaFeriadoSlots.map(({ slotStart, slotEnd }) => ({
        title: feriado.title,
        start: slotStart,
        end: slotEnd,
        display: 'background',
        backgroundColor: 'white',
        classNames: ['d-flex', 'align-items-center', 'justify-content-center'],
        extendedProps: {
          vazio: true,
          tipo: "feriado"
        }
      }));

      eventosFeriado.push(...eventosDoDia);
    }

    this.calendarComponent.getApi().removeAllEvents();
    this.calendarComponent.getApi().addEventSource(eventosFeriado);
    this.calendarComponent.getApi().addEventSource(eventosReais);
    if (currentViewOption !== 'mes') {
      this.calendarComponent.getApi().addEventSource(eventosDisponiveis);
      this.calendarComponent.getApi().addEventSource(eventosBotaoNovo);
    }
  }

  private colideComEventoReal(slotStart: Date, slotEnd: Date, eventosReais: EventInput[]): boolean {
    return eventosReais.some(ev => {
      const realStart = this.parseDate(ev.start);
      const realEnd = this.parseDate(ev.end);
      return slotStart < realEnd && slotEnd > realStart;
    });
  }

  private parseDate(value: any): Date {
    if (value instanceof Date) return value;
    if (Array.isArray(value)) {
      return new Date(...(value as [number, number?, number?, number?, number?, number?, number?]));
    }
    return new Date(value);
  }

  generateSlots(start: Date, end: Date, stepMinutes: number = 30): string[] {
    const slots: string[] = [];
    const current = new Date(start);

    while (current < end) {
      slots.push(current.toISOString());
      current.setMinutes(current.getMinutes() + stepMinutes);
    }

    return slots;
  }

  protected backData(): void {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.prev();
    let ano = calendarApi.getCurrentData().dateProfile.currentRange.end.getFullYear();
    if (ano == this.anoAtual) {
      this.alterData(calendarApi);
      return;
    }
    this.anoAtual = ano;
    this.getFeriados(ano).subscribe(feriados => {
      this.feriados = feriados;
      this.alterData(calendarApi);
    });
  }

  protected nextData(): void {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.next();
    let ano = calendarApi.getCurrentData().dateProfile.currentRange.end.getFullYear();
    if (ano == this.anoAtual) {
      this.alterData(calendarApi);
      return;
    }
    this.anoAtual = ano;
    this.getFeriados(ano).subscribe(feriados => {
      this.feriados = feriados;
      this.alterData(calendarApi);
    });
  }

  private alterData(calendarApi: Calendar): void {
    this.updateTitle(calendarApi);
    this.getEventos();
    if (this.gerenciarHorarios) {
      setTimeout(() => this.atualizarVisibilidadeIcones(), 300);
    }
  }

  protected alterView(option: 'mes' | 'dia' | 'semana'): void {
    const calendarApi = this.calendarComponent.getApi();
    if (option === 'mes') {
      calendarApi.changeView('dayGridMonth');
      this.viewOption = 'mes';
      currentViewOption = 'mes';
      this.currentCalendarView = 'view-mes';
    } else if (option === 'semana') {
      calendarApi.changeView('timeGridWeek');
      this.viewOption = 'semana';
      currentViewOption = 'semana';
      this.currentCalendarView = 'view-semana';
    } else if (option === 'dia') {
      calendarApi.changeView('timeGridDay');
      this.viewOption = 'dia';
      currentViewOption = 'dia';
      this.currentCalendarView = 'view-dia';
    }
    this.updateTitle(calendarApi);
    this.getEventos();
    if (this.gerenciarHorarios) {
      setTimeout(() => this.atualizarVisibilidadeIcones(), 300);
    }
  }

  protected eventoClick(info: any) {
    const evento: EventInput = info.event;
    if (evento.extendedProps.tipo == TipoEvento._2) {
      this.editConsulta(evento.extendedProps.consultaId);
      return;
    }

    if (evento.extendedProps.tipo == "horario-livre") {
        let consulta = new CreateConsultaDto();
        consulta.dataConsulta = moment(evento.start);
        consulta.agendaId = this.agenda.id;
        this.createConsulta(consulta);
    }

    if (evento.extendedProps.vazio) {

      if (evento.extendedProps.tipo == 'botao-novo-evento' && this.gerenciarHorarios) {

        const slotDate = new Date(evento.start.toString());
        const slotDay = slotDate.getDay();
        this.createHorario(slotDay);
      } else {
        return;
      }
    } else {

      this.editEvento(evento.id);
    }
  }

  private editConsulta(consultaId: string): void {
    abp.ui.setBusy();
    this._consultaService.get(consultaId).pipe(
      finalize(() => abp.ui.clearBusy())
    ).subscribe((consulta => {
      const editModal = this._modalService.show(
        EditConsultaComponent,
        {
          class: 'modal-md',
          ignoreBackdropClick: true,
          initialState: {
            tipoUsuario: this.appSession.user.tipoUsuarioEnum,
            consulta: UpdateConsultaDto.fromJS(consulta.toJSON())
          }
        }
      );

      editModal.content.onSave.subscribe(() => {
        this.getEventos();
        abp.notify.success("Consulta editada com sucesso!");
      });
    }));
  }

  protected getPacientes(): Observable<PacienteGroupDto[]> {
    const profissionalId = this.appSession.clinicaId ? null : this.appSession.profissionalId;
    return this._pacienteService.getPacientesForGroup(profissionalId, this.appSession.clinicaId);
  }


  private async createConsulta(consulta: CreateConsultaDto): Promise<void> {
    const pacientes = await this.getPacientes().toPromise();
    const createModal = this._modalService.show(
      CreateConsultaComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          tipoUsuario: this.appSession.user.tipoUsuarioEnum,
          consulta: consulta,
          profissionais: this.agenda.profissionais.map(x => x.profissionalSaude),
          pacientes: pacientes,
        }
      }
    );

    createModal.content.onSave.subscribe(() => {
      this.getEventos();
      abp.notify.success("Consulta criada com sucesso!");
    });
  }

  protected editEvento(eventoId: string) {

    const createModal = this._modalService.show(
      EditEventoComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          id: eventoId,
          horaInicioAgenda: this.agenda.horarioInicio,
          horaFimAgenda: this.agenda.horarioFim
        }
      }
    );

    createModal.content.onSave.subscribe(() => {
      this.getEventos();
      abp.notify.success("Evento editado com sucesso!");
    });
  }

  protected createEvento(evento: CreateEventoDto = undefined): void {
    const createModal = this._modalService.show(
      CreateEventoComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          agenda: this.agenda,
          evento: evento
        },
      }
    );

    createModal.content.onSave.subscribe(() => {
      this.getEventos();
      abp.notify.success("Evento cadastrado com sucesso!");
    });
  }

  protected createHorario(diaDaSemana: number): void {
    const createModal = this._modalService.show(
      CreateHorarioDisponivelComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          agendaId: this.agenda.id,
          diaDaSemana: diaDaSemana
        },
      }
    );

    createModal.content.onSave.subscribe(() => {
      this.getEventos();
      abp.notify.success("Horário cadastrado com sucesso!");
    });
  }

  protected abrirGerenciarDia(data: Date): void {
    const modal = this._modalService.show(
      GerenciarDisponibilidadeDiaComponent,
      {
        class: 'modal-lg',
        ignoreBackdropClick: true,
        initialState: {
          data: data,
          agenda: this.agenda
        }
      }
    );

    modal.content.onAlterado.subscribe(() => {
      this.getEventos();
    });
  }

  private updateTitle(calendarApi: any): void {
    this.title = calendarApi.view.title;
  }

  private onDateClick(info: any): void {
    if (info.view.type !== 'dayGridMonth' || !this.gerenciarHorarios) return;
    const target = info.jsEvent.target as HTMLElement;
    if (target.closest('[data-action="gerenciar-dia"]')) return;
    this.createHorario(info.date.getDay());
  }

  private customDayCellDidMount(args: any): void {
    if (args.view.type !== 'dayGridMonth' || !this.gerenciarHorarios) return;

    const dayTop: HTMLElement = args.el.querySelector('.fc-daygrid-day-top');
    if (!dayTop) return;

    const pencil = document.createElement('i');
    pencil.className = 'hgi hgi-stroke hgi-pencil-edit-02';
    pencil.setAttribute('data-action', 'gerenciar-dia');
    pencil.setAttribute('data-date', (args.date as Date).toISOString());
    pencil.setAttribute('title', 'Gerenciar disponibilidade');
    pencil.style.cssText = 'color:#E2A150; font-size:1.3rem; cursor:pointer; padding:6px; margin-right:auto;';

    dayTop.appendChild(pencil);
  }

  private customDayHeader(args: any) {
    const viewType: string = args.view.type;
    const diasDaSemana = [
      'DOMINGO',
      'SEGUNDA-FEIRA',
      'TERÇA-FEIRA',
      'QUARTA-FEIRA',
      'QUINTA-FEIRA',
      'SEXTA-FEIRA',
      'SÁBADO'
    ];

    const date: Date = args.date;
    const today = new Date();
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    if (viewType === 'dayGridMonth') {
      const dow: number = args.dow ?? date.getDay();
      const weekday = diasDaSemana[dow];
      return {
        html: `<div style="text-align: center;">${weekday}</div>`
      };
    }

    const weekday = date.toLocaleDateString('pt-BR', { weekday: 'long' }).toUpperCase();
    const dayNumber = date.getDate().toString().padStart(2, '0');

    const dayNumberStyle = isToday
      ? 'background-color: #E2A150; color: white; padding: 1px 12px 1px 12px; border-radius: 50px;'
      : 'color: #374151';

    return {
      html: `
        <div style="display:flex; flex-direction:column; align-items:center; line-height:1.2; width:100%; padding:4px 0;">
          <div style="display:flex; align-items:center; gap:6px;">
            <div class="texto-dia-semana" style="font-weight:500; font-size:1rem; color:#6D7280; font-family:'Poppins';">${weekday}</div>
            ${this.gerenciarHorarios ? `
            <i class="hgi hgi-stroke hgi-pencil-edit-02"
              data-action="gerenciar-dia"
              data-date="${date.toISOString()}"
              title="Gerenciar disponibilidade"
              style="color:#E2A150; font-size:1.2rem; cursor:pointer; flex-shrink:0;">
            </i>` : ''}
          </div>
          <div class="texto-numero-dia" style="font-size:1.5rem; font-weight:400; margin-top:5px; font-family:'Poppins'; ${dayNumberStyle}">${dayNumber}</div>
        </div>`
    };
  }

  public getEventos(): Subscription {
    const { start, end } = this.getVisibleDateRange();

    return this._eventoService
      .getAll(moment(start), moment(end), this.agenda.id, this.appSession.profissionalId, undefined, undefined)
      .subscribe((result) => {
        this.eventos = result.items.map(this.buildEventoReal);
        this.refreshCalendar();
      });
  }

  private getVisibleDateRange(): { start: Date, end: Date } {
    const calendarApi = this.calendarComponent?.getApi?.();
    const start = calendarApi?.view?.activeStart;
    const end = calendarApi?.view?.activeEnd;

    if (start && end) {
      return { start, end };
    }

    const today = new Date();
    const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastDayNextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0); // dia 0 do mês +2 = último do mês +1

    return {
      start: firstDayPrevMonth,
      end: lastDayNextMonth
    };
  }

  private refreshCalendar(): void {
    const calendarApi = this.calendarComponent.getApi();

    const currentView = calendarApi.view;
    const start = currentView.activeStart;
    const end = currentView.activeEnd;

    this.onDatesSet({
      start,
      end,
      startStr: start.toISOString(),
      endStr: end.toISOString(),
      view: currentView,
      timeZone: calendarApi.getCurrentData().calendarOptions.timeZone
    });
  }

  private buildEventoReal(evento: EventoDto): EventInput {
    return {
      id: evento.id,
      title: evento.titulo,
      start: evento.inicio.format('YYYY-MM-DDTHH:mm'),
      end: evento.fim.format('YYYY-MM-DDTHH:mm'),
      status: evento?.consulta?.statusConsulta ?? StatusConsultaEnum._0,
      classNames: ["p-4"],
      extendedProps: {
        consultaId: evento.consulta?.id ?? null,
        nomePaciente: evento.consulta?.paciente?.nome ?? null,
        urlFoto: evento.consulta?.paciente?.urlFotoPerfil ?? null,
        vazio: false,
        tipo: evento.tipo,
        nome: evento.titulo,
        horario: `${evento.inicio.format('HH:mm')} - ${evento.fim.format('HH:mm')}`,
        status: evento?.consulta?.statusConsulta ?? StatusConsultaEnum._0,
        tipoConsulta: evento?.consulta?.tipoConsultaString ?? ""
      }
    };
  }

  private buildEventoDisponivel(start: Date, end: Date): EventInput {
    return {
      title: 'Horário disponível',
      start: start.toISOString(),
      end: end.toISOString(),
      display: 'background',
      backgroundColor: 'white',
      classNames: ['d-flex', 'align-items-center', 'justify-content-center'],
      extendedProps: {
        vazio: true,
        tipo: "horario-livre"
      }
    };
  }

  private buildEventoBotao(start: Date, end: Date): EventInput {
    return {
      title: 'Botão',
      start: start.toISOString(),
      end: end.toISOString(),
      display: 'background',
      backgroundColor: 'white',
      classNames: ['pt-4', 'pr-4', 'd-flex', 'align-items-start', 'justify-content-end'],
      extendedProps: {
        vazio: true,
        tipo: 'botao-novo-evento',
      }
    };
  }

  private getFeriados(ano: number): Observable<EventInput[]> {
    return this.http.get<any[]>(`https://brasilapi.com.br/api/feriados/v1/${ano}`).pipe(
      map(feriados => feriados.map(f => ({
        title: f.name,
        start: f.date,
        allDay: true,
        display: 'background',
        backgroundColor: 'white',
        classNames: ['d-flex', 'align-items-center', 'justify-content-center'],
        extendedProps: {
          vazio: true,
          tipo: "feriado"
        }
      })))
    );
  }

  private atualizarVisibilidadeIcones(): void {
    if (!this.gerenciarHorarios) return;
      document
        .querySelectorAll<HTMLElement>('.icone-gerenciar-dia')
        .forEach(el => el.style.display = 'block');
    }
}
